import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'

import AppUtils from '../../utils/AppUtils'
import AppConstants from '../../utils/AppConstants'
import ColumnsProvider from '../../utils/ColumnsProvider'
import Page from '../../components/elements/Page'
import Header from '../../components/elements/Header'
import Table from '../../components/elements/Table'
import Confirm from '../../components/elements/Confirm'
import CreateUserPopup from '../popups/users/CreateUserPopup'
import UpdateUserPopup from '../popups/users/UpdateUserPopup'
import Grant from '../elements/Grant'

import Types from '../../actions/Types'
import ListAction from '../../actions/users/ListAction'
import DeleteAction from '../../actions/users/DeleteAction'
import ClearErrorAction from '../../actions/app/ClearErrorAction'
import ChangePageAction from '../../actions/app/ChangePageAction'

const TABLE_PERSPECTIVE = {
  PERMISSIONS: 'PERMISSIONS',
  RESPONSIBILITIES: 'RESPONSIBILITIES'
}

class UsersPage extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      isCreate: false,
      updateId: null,
      deleteId: null,
      perspective: props.isAdmin ? TABLE_PERSPECTIVE.PERMISSIONS : TABLE_PERSPECTIVE.RESPONSIBILITIES
    }

    // Bind events
    this.onClickCreate = this.onClickCreate.bind(this)
    this.onCloseCreate = this.onCloseCreate.bind(this)
    this.onClickUpdate = this.onClickUpdate.bind(this)
    this.onCloseUpdate = this.onCloseUpdate.bind(this)
    this.onClickDelete = this.onClickDelete.bind(this)
    this.onConfirmDelete = this.onConfirmDelete.bind(this)
    this.onClickPerspective = this.onClickPerspective.bind(this)
    this.onClickSelectControl = this.onClickSelectControl.bind(this)
    this.onClickSelectProduct = this.onClickSelectProduct.bind(this)
  }

  componentDidMount() {
    this.props.fetch()
  }

  componentDidUpdate(prevProps, prevState) {
    // After a location has been deleted, refresh
    if (
      prevProps.deleteIsFetching
      &&
      !this.props.deleteIsFetching
    ) {
      this.setState({
        deleteId: null
      })
      AppUtils.setStatus(
        this.props.deleteError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.deleteError
          ? AppUtils.errorToText(this.props.deleteError, {
              [AppConstants.ERROR.BAD_REQUEST.RESOURCE_IN_USE]: "L'utilisateur courant ne peut pas être supprimé."
            })
          : 'Utilisateur supprimé.'
      )
      if (!this.props.deleteError) {
        this.props.fetch()
      }
    }
  }

  onClickCreate() {
    this.setState({
      isCreate: true
    })
  }

  onCloseCreate(isDirty) {
    this.setState({
      isCreate: false
    })
    if (isDirty) {
      this.props.fetch()
    }
  }

  onClickUpdate(id) {
    return () => {
      this.setState({
        updateId: id
      })
    }
  }

  onCloseUpdate(isDirty) {
    this.setState({
      updateId: null
    })
    if (isDirty) {
      this.props.fetch()
    }
  }

  onClickDelete(id) {
    return () => {
      this.setState({
        deleteId: id
      })
    }
  }

  onConfirmDelete(proceed) {
    if (proceed) {
      this.props.delete(this.state.deleteId)
    }
    else {
      this.setState({
        deleteId: null
      })
    }
  }

  onClickPerspective(perspective) {
    return () => {
      this.setState({
        perspective
      });
    }
  }

  onClickSelectControl(id) {
    return () => {
      this.props.changePage(AppConstants.PAGE.CONTROL_VIEW, id)
    }
  }

  onClickSelectProduct(id) {
    return () => {
      this.props.changePage(AppConstants.PAGE.PRODUCTS_VIEW, id)
    }
  }

  render() {
    return (
      <React.Fragment>
        <Page direction={Page.DIRECTION.ROW}>
          <Page.Element
            flex='1 1 100%'
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Header
              style={{
                flex: '0 1 auto'
              }}
              title='Utilisateurs'
              right={
                <Grant role={Grant.ROLE.ADMIN}>
                  <Button.Group
                    compact={true}
                    style={{
                      marginRight: '8px'
                    }}
                  >
                    <Button
                      content="Permissions"
                      active={this.state.perspective === TABLE_PERSPECTIVE.PERMISSIONS}
                      onClick={this.onClickPerspective(TABLE_PERSPECTIVE.PERMISSIONS)}
                    />
                    <Button
                      content="Responsabilités"
                      active={this.state.perspective === TABLE_PERSPECTIVE.RESPONSIBILITIES}
                      onClick={this.onClickPerspective(TABLE_PERSPECTIVE.RESPONSIBILITIES)}
                    />
                  </Button.Group>
                  <Button
                    compact={true}
                    icon='plus'
                    content='Créer'
                    color='green'
                    onClick={this.onClickCreate}
                  />
                </Grant>
              }
            />
            <Table
              columns={[].concat(
                [
                  // Nom et prénom
                  ColumnsProvider.userNameAndFirstName
                ],
                this.props.isAdmin
                  ? [
                      // Nom d'utilisateur
                      ColumnsProvider.userUsername
                    ]
                  : [],
                this.state.perspective === TABLE_PERSPECTIVE.PERMISSIONS
                  ? [
                      // Connexion
                      ColumnsProvider.userPermission('Connexion', 'login', 90),
                      // Inventaire
                      ColumnsProvider.userPermission('Inventaire', 'inventory', 100),
                      // Maintenance
                      ColumnsProvider.userPermission('Maintenance', 'maintenance', 100),
                      // Gestion
                      ColumnsProvider.userPermission('Gestion', 'manage', 90),
                      // Administrateur
                      ColumnsProvider.userPermission('Administrateur', 'admin', 120)
                    ]
                  : [
                      // Groupe matériel
                      ColumnsProvider.userRespHardwareGroup,
                      // Groupe de contrôle
                      ColumnsProvider.userRespControlGroup(this.onClickSelectControl),
                      // Entretien
                      ColumnsProvider.userRespMaintenanceContact(
                        this.onClickSelectControl,
                        this.onClickSelectProduct
                      )
                    ],
                [
                  // Actions
                  ColumnsProvider.actionsUpdateDelete(
                    this.onClickUpdate,
                    this.onClickDelete,
                    Grant.ROLE.ADMIN,
                    Grant.ROLE.ADMIN
                  )
                ]
              )}
              data={this.props.list}
              error={this.props.error}
              isLoading={this.props.isFetching}
              emptyMessage="Il n'existe aucun utilisateur pour le moment."
            />
          </Page.Element>
        </Page>
        {
          this.state.isCreate
            ? <CreateUserPopup
                onClose={this.onCloseCreate}
              />
            : null
        }
        {
          !_.isNull(this.state.updateId)
            ? <UpdateUserPopup
                id={this.state.updateId}
                onClose={this.onCloseUpdate}
              />
            : null
        }
        {
          !_.isNull(this.state.deleteId)
            ? <Confirm
                header="Suppression d'un utilisateur"
                body="Êtes-vous sûr de vouloir supprimer cet utilisateur ?"
                confirmText='Supprimer'
                confirmColor='red'
                confirmIcon='trash'
                isProceeding={this.props.deleteIsFetching}
                callback={this.onConfirmDelete}
              />
            : null
        }
      </React.Fragment>
    )
  }
}

UsersPage.propTypes = {
  // Properties

  // Redux State
  list: PropTypes.array,
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.object,
  deleteIsFetching: PropTypes.bool.isRequired,
  deleteError: PropTypes.object,
  isAdmin: PropTypes.bool.isRequired,

  // Redux Actions
  fetch: PropTypes.func.isRequired,
  delete: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    list: state.entities.users.list.data,
    isFetching: state.entities.users.list.isFetching,
    error: state.entities.users.list.error,
    deleteIsFetching: state.entities.users.delete.isFetching,
    deleteError: state.entities.users.delete.error,
    isAdmin: state.app.identity.user && state.app.identity.user.authorizations && state.app.identity.user.authorizations.admin
  }),
  (dispatch) => ({
    fetch: () => (dispatch(ListAction({}))),
    delete: (id) => (dispatch(DeleteAction({ id }))),
    clearError: () => (dispatch(ClearErrorAction(Types.USERS.LIST))),
    changePage: (page, id) => (dispatch(ChangePageAction(page, { id })))
  })
)(UsersPage)



// WEBPACK FOOTER //
// ./src/containers/pages/UsersPage.js